import { render, staticRenderFns } from "./index.vue?vue&type=template&id=46b164bd&scoped=true"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"
import style0 from "./index.vue?vue&type=style&index=0&id=46b164bd&prod&scoped=true&lang=less"
import style1 from "./index.vue?vue&type=style&index=1&id=46b164bd&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46b164bd",
  null
  
)

export default component.exports